import { useMemo } from 'react';
import { useRouter } from 'next/router';
import camelCase from 'lodash/camelCase';
import { TabLink } from '@framework/router/Next/Link';
import { useStatsContext } from '@/creditflowresearch/application/ArticlesAndStats/Stats/StatsContext';
import { IQueryParams } from '@/creditflowresearch/domain/vo/IQueryParams';
import { removeQueryParams } from '@framework/router';
import { getCategoryUrl } from '../helpers';

import styles from './styles.module.scss';

const CategoriesList = () => {
  const { query: routeParams }:{ query: IQueryParams } = useRouter();
  const { categories } = useStatsContext();
  const query = useMemo<IQueryParams>(
    () => removeQueryParams(routeParams, ['categoryId']),
    [routeParams],
  );

  return (
    <div className={ styles.categoriesListContainer } data-test="categoriesTabs">
      <TabLink
        className={ styles.categoryItem }
        activeClassName={ styles.activeCategoryItem }
        to={ getCategoryUrl('all', query) }
        dataTest="allTab"
      >
        All
      </TabLink>

      {
        categories.map((category) => (
          <TabLink
            className={ styles.categoryItem }
            activeClassName={ styles.activeCategoryItem }
            to={ getCategoryUrl(category.id, query) }
            key={ category.id }
            dataTest={ `${ camelCase(category.name) }Tab` }
          >
            { category.name }
          </TabLink>
          ))
      }
    </div>
  );
};

export default CategoriesList;
